// src/pages/HomePage.jsx

import { TrustedBy } from "../components/trustedBy";
import { InfoCardsSection } from "../components/infoCard";
import { FeatureShowcase } from "../components/featureshowcase";
import { IntroductionTabs } from "../components/introductionTabs";
import { PricingTable } from "../components/pricingTable";
import { ActionPromoSection } from "../components/actionPromo";
import { ServiceHighlights } from "../components/servicehighlights";
import { ContactSection } from "../components/contacts";
import { FAQSection } from "../components/faq";
// import { HeroAnimation } from "../components/heroAnimation";
import { HeroAnimation } from '../components/HeroAnimation';
// This component now contains all the sections for your main landing page.
export default function HomePage() {
  return (
    <>
      <HeroAnimation />
      <TrustedBy />
      <InfoCardsSection />
      <FeatureShowcase />
      <IntroductionTabs />
      <PricingTable />
      <ActionPromoSection />
      <ServiceHighlights/>
      <ContactSection />
      <FAQSection />
    </>
  );
}